import * as React from 'react';
const Translate = require('react-redux-i18n').Translate;

import { BarType } from '../../containers/NotificationBar/actions';
import { NotificationBarState } from '../../containers/NotificationBar/reducer';
import { StyledNotificationBar, StyledNotificationText } from './styles';
import { StyleColor } from '../../utils/styles-constants';

interface NotificationBarProps {
	notificationBar: NotificationBarState;
}

const NotificationBar = ({ notificationBar }: NotificationBarProps) => {
	const notifications = notificationBar.history;

	const errors = notifications.filter((notification, index, self) => {
		return notification.barType === BarType.Error && index === self.findIndex(selfNotification => {
			if (notification.args && selfNotification.args) {
				return selfNotification.message === notification.message
					&& selfNotification.args.id === notification.args.id;
			}
			return selfNotification.message === notification.message;
		});
	});

	const infos = notifications.filter(notification => notification.barType === BarType.Info);
	const successes = notifications.filter(notification => notification.barType === BarType.Success);

	let info = infos.length > 0
		? (
			<Translate
				value={`${infos[0].barType}.${infos[0].message}`}
				{...infos[0].args}
				dangerousHTML={true}
			/>
		)
		: '';

	let success = successes.length > 0
		? (
			<Translate
				value={`${successes[0].barType}.${successes[0].message}`}
				{...successes[0].args}
				dangerousHTML={true}
			/>
		)
		: '';

	let error;

	if (errors.length > 1) {
		error = (
			<Translate
				value={`${errors[0].barType}.bundle_${errors[0].message}`}
				number={errors.length}
				dangerousHTML={true}
			/>
		);
	} else if (errors.length === 1) {
		error = (
			<Translate
				value={`${errors[0].barType}.${errors[0].message}`}
				{...errors[0].args}
				dangerousHTML={true}
			/>
		);
	} else {
		error = '';
	}

	return (
		<StyledNotificationBar className="NotificationBar" isShown={!!notifications.length}>
			{!!errors.length &&
				<StyledNotificationText color={StyleColor.Red}>{error}</StyledNotificationText>
			}
			{!!infos.length &&
				<StyledNotificationText color={StyleColor.White}>{info}</StyledNotificationText>
			}
			{!!successes.length &&
				<StyledNotificationText color={StyleColor.Green}>{success}</StyledNotificationText>
			}
		</StyledNotificationBar>
	);
};

export default NotificationBar;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NotificationBar/index.tsx